// extracted by mini-css-extract-plugin
export default {"custom":"Button_custom__7LAsP","primary":"Button_primary__fmhg1","light":"Button_light__5E2XB","action-button":"Button_action-button__X7P8Z"};